import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Row, Col, Table, Alert } from 'react-bootstrap';
import '../css/main.css';
import { authContext } from '../AzureAd';

export default class MaintenanceFixTargetComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        this.props.findAuditableDetails(
            this.props.request.get('card'),
            this.props.request.get('type')
        );
    }

    toPreviousPage() {
        hashHistory.push("/auditingCards");
    }

    detailAudited(detail) {
        this.props.detailAudited(detail,
            this.props.response.get("card"),
            this.props.request.get("type"),
            authContext.getCachedUser().userName);
    }

    backToFixing(detail) {
        this.props.backToFixing(detail,
            this.props.response.get("card"),
            this.props.request.get("type"));
    }

    disabledCompleteAudit(card) {
        let type = this.props.request.get("type");
        switch (type) {
            case "CLOTH":
                return (card.noClothes || card.discardClothes);
            case "PANT":
                return (card.noPant || card.discardPant);
        }
    }

    completeAudit(card) {
        let type = this.props.request.get("type");
        if(this.checkNeedTakePic()) {   //是否需檢查需要拍照
            switch (type) {
                case "CLOTH":
                    if ("NONE" === card.postClothesSnap || "UNDONE" === card.postClothesSnap) {
                        alert("消防衣需先拍兩張以上照片");
                        return;
                    }
                    break;
                case "PANT":
                    if ("NONE" === card.postPantSnap || "UNDONE" === card.postPantSnap) {
                        alert("消防褲需先拍兩張以上照片");
                        return;
                    }
                    break;
            }
        }
        this.props.completeAudit(card, type, authContext.getCachedUser().userName);
    }

    showPhotoBlk() {
        // let typeString = this.props.request.get("type");
        this.props.expandContent();
        hashHistory.push("/takePostPhoto");
    }

    // 如果 detail 均為 REMOVED 或 ESCAPE 則不需要拍照
    checkNeedTakePic() {
        let result = true;
        let cnt = 0;
        this.props.response.get('details').map((detail, index) => {
            if (!("REMOVED" === detail.refineStatus || "ESCAPE" === detail.refineStatus)) {
                cnt++;
            }
        });
        if (cnt === 0) {
            result = false;
        }
        return result;
    }

    render() {

        let refineStatus = function (detail) {
            if ("REMOVED" === detail.refineStatus) {
                return "業主刪除項目"
            }
            if ("APPEND" === detail.refineStatus) {
                return "業主追加項目";
            }
            if ("ESCAPE" === detail.refineStatus) {
                return "建議但業主不願追加";
            }
        }

        let detailStatus = function (detail) {
            let statusKey = detail.status;
            switch (statusKey) {
                case 'CREATED':
                    if (detail.refineStatus === "REMOVED") {
                        return '業主剔除';
                    } else {
                        return '未維修';
                    }
                case 'FIXED':
                    if (detail.refineStatus === "ESCAPE") {
                        return '經費不足或業主剔除';
                    } else if (detail.refineStatus === "REMOVED") {
                        return '業主剔除';
                    } else {
                        return '尚未檢點';
                    }
                case 'AUDITED':
                    return '檢點完成';
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",//red
                        verticalAlign: "middle"
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",//green
                        verticalAlign: "middle"
                    };
                case 'CREATED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#EBEBFF",//blue
                        verticalAlign: "middle"
                    };
                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'CREATED':
                    return "highlight-blue";
                case 'FIXED':
                    return "highlight-red";
                case 'AUDITED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let snapStatus = (status) => {
            switch (status) {
                case 'NONE':
                    return '未拍照';
                case 'UNDONE':
                    return '拍照進行中';
                case 'CAPTURED':
                    return '已拍照';
                case 'SKIPPED':
                    return '不須拍照';
                default:
                    return "";
            }
        }

        let cardStatus = function (status) {
            switch (status) {
                case 'REFINED':
                    return '待維修';
                case 'FIXING':
                    return '維修中';
                case 'FIXED':
                    return '需檢點';
                case 'AUDITED':
                    return '檢點完成';
                default:
                    return "";
            }
        }

        let highlightSnap = function (snap) {
            switch (snap) {
                case 'SKIPPED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#EBEBFF",
                    };
                case 'NONE':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'UNDONE':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FDE8BD",
                    };
                case 'CAPTURED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",
                    };
                default:
                    return {};
            }
        }
        let highlightSnapClassNameCard = function (snap) {
            switch (snap) {
                case 'SKIPPED':
                    return "highlight-blue";
                case 'NONE':
                    return "highlight-red";
                case 'UNDONE':
                    return "highlight-blue";
                case 'CAPTURED':
                    return "highlight-green";
                default:
                    return {};
            }
        }


        let highlightAuditClass = function (bool) {
            if (bool) {
                return "highlight-green";
            } else {
                return "highlight-red";
            }
        }

        let highlightAudit = (bool) => {
            if (bool) {
                return {
                    textAlign: "center",
                    backgroundColor: "#96FF96",
                };
            } else {
                return {
                    textAlign: "center",
                    backgroundColor: "#FFBFBF",
                };
            }
        }

        let highlightCard = function (card) {
            switch (card.status) {
                case 'REFINED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#EBEBFF",
                    };
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#96FF96",
                    };
                default:
                    return {};
            }
        }

        let highlightClassNameCard = function (card) {
            switch (card.status) {
                case 'REFINED':
                    return "highlight-blue";
                case 'FIXING':
                    return "highlight-red";
                case 'FIXED':
                    return "highlight-red";
                case 'AUDITED':
                    return "highlight-green";
                default:
                    return '';
            }
        }

        let alignCenter = {
            textAlign: "center",
            verticalAlign: "middle"
        }

        let card = this.props.response.get("card");

        let titleImg = () => {
            let type = this.props.request.get("type");
            if (type) {
                if ("CLOTH" === type) {
                    return "shirt.svg"
                } else if ("PANT" === type) {
                    return "shorts.svg"
                } else {
                    return "kk25.jpg"
                }
            } else {
                return "kk25.jpg"
            }
        }

        let titleDesc = () => {
            let type = this.props.request.get("type");
            if (type) {
                if ("CLOTH" === type) {
                    return "消防衣"
                } else if ("PANT" === type) {
                    return "消防褲"
                } else {
                    return "Taiwan K.K. "
                }
            } else {
                return "Taiwan K.K. "
            }
        }

        let disabledFixedButton = (detail) => {
            if (detail.status === "FIXED" && detail.refineStatus !== "REMOVED") {
                return false;
            }
            return true;
        }

        let disabledBackFixedButton = (detail) => {

            if (detail.refineStatus === "ESCAPE"
                || detail.refineStatus === "REMOVED") {
                //不維修或以移除
                return true;
            }

            if (detail.status === "FIXED") {
                return false;
            }
            return true;
        }

        let auditedStatus = (status) => {
            if (status) {
                return "已檢點"
            } else {
                return "待檢點"
            }
        }

        let toSimpleDate = (date) => {
            var yyyy = date.getFullYear().toString();
            var mm = (date.getMonth() + 1).toString();
            var dd = date.getDate().toString();

            // CONVERT mm AND dd INTO chars
            var mmChars = mm.split('');
            var ddChars = dd.split('');

            // CONCAT THE STRINGS IN YYYY-MM-DD FORMAT
            var datestring = yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
            return datestring;
        }

        return (
            <div>
                <h4><span hidden> MaintenanceAuditTargetComponent </span><img alt={titleDesc()} src={titleImg()} title={titleDesc()} height="40" width="40" />
                    檢點作業 &gt;&gt; 維修卡 &gt;&gt; {card.code} {titleDesc()}&nbsp;
                    <a onClick={(e) => { this.toPreviousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                </h4>
                <Row style={{ marginLeft: -15, marginTop: 10, marginBottom: 10 }}>
                    <Col xs={12} sm={6}>
                        <Button bsSize="large" bsStyle="warning"
                            disabled={this.disabledCompleteAudit(this.props.response.get("card"))}
                            onClick={(event) => {
                                this.completeAudit(this.props.response.get("card"));
                            }}>完成檢點
                        </Button>
                    </Col>
                    <Col xs={12} sm={6}>
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={(event) => { this.showPhotoBlk(); }} >
                                <img alt='take photos' src='camera.svg' height="30" width="30" />
                            </Button>
                        </div>
                    </Col>
                </Row>

                <span hidden>MaintenanceAuditTargetComponent </span>
                <Alert bsStyle={this.props.alert.get('style')} hidden={this.props.alert.get('message') == null}>
                    {this.props.alert.get('message')}
                </Alert>

                <table style={{ width: "100%" }} className="main" >
                    <tr>
                        <th width="8%">訂單</th>
                        <td width="14%">{this.props.request.get("mcase").orderId}<br />{this.props.request.get("mcase").note}</td>
                        <th width="8%">使用者</th>
                        <td width="10%">{card.owner}</td>
                        <th width="8%">維修卡</th>
                        <td width="12%" className={"highlight"} style={{ textAlign: "center" }} >{card.code}<br />{titleDesc()}</td>
                        <th width="8%">拍照(衣)</th>
                        <td width="12%" style={highlightSnap(card.postClothesSnap)}
                            className={highlightSnapClassNameCard(card.postClothesSnap)}>
                            <img alt='消防衣' src='shirt.svg' title='消防衣' height="25" width="25" />
                            {snapStatus(card.postClothesSnap)}</td>
                        <th width="8%">拍照(褲)</th>
                        <td width="12%" style={highlightSnap(card.postPantSnap)}
                            className={highlightSnapClassNameCard(card.postPantSnap)}>
                            <img alt='消防褲' src='shorts.svg' title='消防衣' height="25" width="25" />
                            {snapStatus(card.postPantSnap)}</td>
                    </tr>

                    <tr>
                        <th>客戶</th>
                        <td>{this.props.request.get("mcase").customer.customerName}</td>
                        <th>建立</th>
                        <td>{toSimpleDate(new Date(this.props.request.get("mcase").createTime))}</td>
                        <th>狀態</th>
                        <td style={highlightCard(card)}
                            className={highlightClassNameCard(card)}>{cardStatus(card.status)}</td>
                        <th>檢點</th>
                        <td style={highlightAudit(this.props.response.get("card").clothesAudited)}
                            className={highlightAuditClass(this.props.response.get("card").clothesAudited)} >
                            <img alt='消防衣' src='shirt.svg' title='消防衣' height="25" width="25" />
                            {auditedStatus(this.props.response.get("card").clothesAudited)}
                        </td>
                        <th>檢點</th>
                        <td style={highlightAudit(this.props.response.get("card").pantAudited)}
                            className={highlightAuditClass(this.props.response.get("card").pantAudited)} >
                            <img alt='消防褲' src='shorts.svg' title='消防衣' height="25" width="25" />
                            {auditedStatus(this.props.response.get("card").pantAudited)}
                        </td>
                    </tr>
                </table>

                <h4><img alt={titleDesc()} src={titleImg()} title={titleDesc()} height="40" width="40" />{titleDesc()} {card.code} 需 [檢點] 項目</h4>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th width="5%" style={alignCenter}>序號</th>
                            <th width="15%">類別</th>
                            <th width="20%">維修項目</th>
                            <th>附註</th>
                            <th width="10%" colSpan='2'>動作 (檢點)</th>
                            <th width="10%">狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.response.get('details').map(
                                (item, index) =>
                                    <tr key={index}>
                                        <td style={alignCenter}>{index + 1}</td>
                                        <td>{item.checkSet.description}</td>
                                        <td>{item.checkItem.description}</td>
                                        <td>{refineStatus(item)}{item.note}</td>
                                        <td>
                                            <Button bsStyle="info"
                                                disabled={disabledFixedButton(item)}
                                                onClick={(event) => {
                                                    this.detailAudited(item);
                                                }}
                                            >
                                                <img alt={titleDesc()} src={titleImg()} height="25" width="25" /> 標記檢點
											</Button>
                                        </td>
                                        <td>
                                            <Button bsStyle="info"
                                                disabled={disabledBackFixedButton(item)}
                                                onClick={(event) => {
                                                    this.backToFixing(item);
                                                }}
                                            >
                                                <img alt={titleDesc()} src={titleImg()} height="25" width="25" /> 退回處理
											</Button>
                                        </td>
                                        <td style={highlight(item.status)} className={highlightClassName(item.status)}>{detailStatus(item)}</td>
                                    </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceAuditTargetComponent.jsx